import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";

import { catchError, map } from "rxjs/operators";
import { throwError } from "rxjs";

import { TechnologicalFunction } from "../models";

import { environment } from "environments/environment";

@Injectable({providedIn: 'root'})
export class TechnologicalFunctionService {

    constructor(private _http: HttpClient){}

    /**
     * Función que retorna listado de funciones tecnologivas
     * @returns retorna listado de funciones tecnologicas
     */
    getAll(){
        return this._http.get<TechnologicalFunction[]>(`${environment.rydApiUrl}/api/technological-function`);
    }

    /**
     * Función para crear una función tecnologica
     * @param {TechnologicalFunction} technologicalFunction 
     * @returns 
     */
    addTechnologicalFunction(technologicalFunction: TechnologicalFunction){
        return this._http.post<TechnologicalFunction>(`${environment.rydApiUrl}/api/technological-function`, technologicalFunction)
        .pipe(
            map((response: any) => response.technologicalFunction as TechnologicalFunction),
            catchError(e =>{
                return throwError(e);
            })
        );
    }

    /**
     * Función para editar una función tecnologica
     * @param {TechnologicalFunction} technologicalFunction 
     * @returns 
     */
    editTechnologicalFunction(technologicalFunction: TechnologicalFunction){
        return this._http.put<TechnologicalFunction>(`${environment.rydApiUrl}/api/technological-function/${technologicalFunction.id}`, technologicalFunction)
        .pipe(
            map((response: any) => response.technologicalFunction as TechnologicalFunction),
            catchError(e =>{
                return throwError(e);
            })
        );
    }

    /**
     * Función para eliminar una función tecnologica
     * @param {number} id 
     * @param {number} statusId 
     * @returns 
     */
    changeStatus(id: number, statusId: number){
        return this._http.put<TechnologicalFunction>(`${environment.rydApiUrl}/api/technological-function/${id}/${statusId}`, {})
        .pipe(
            map((response: any) => response.technologicalFunction as TechnologicalFunction),
            catchError(e =>{
                return throwError(e);
            })
        );
    }
}
